export { default } from "./InsufficientPriviledges";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/InsufficientPriviledges/index.js